import {
  createTheme,
  DEFAULT_THEME,
  TextInput,
  NumberInput,
  Select,
  Textarea,
  FileInput,
} from '@mantine/core';
import { DatePickerInput, DateTimePicker, TimePicker } from '@mantine/dates';
import { DEFAULT_THEME_COLOR, normalizeThemeColor } from './config/themeColors';
import { DATE_PICKER_DEFAULT_PROPS, INPUT_GUARD_PROPS, TIME_PICKER_DEFAULT_PROPS } from './config/inputGuardProps';

/** Évite la troncature des chiffres (ex. « 10 : 00 » → « 10 : 0C ») dans le TimePicker Mantine. */
const TIME_PICKER_STYLES = {
  fieldsRoot: { overflow: 'visible' },
  fieldsGroup: { flexWrap: 'nowrap' },
  field: {
    width: 'calc(2.75ch + 0.5em)',
    minWidth: '2.75ch',
    paddingInline: '0.2em',
  },
};

const DATE_TIME_PICKER_STYLES = {
  timeWrapper: { minWidth: 0 },
  timeInput: { flex: 1, minWidth: 0, overflow: 'visible' },
};

export function createJlfcTheme(primaryColor = DEFAULT_THEME_COLOR) {
  const color = normalizeThemeColor(primaryColor);
  return createTheme({
    fontFamily: 'DM Sans, system-ui, sans-serif',
    headings: { fontFamily: 'DM Sans, system-ui, sans-serif' },
    primaryColor: color,
    defaultRadius: 'md',
    colors: DEFAULT_THEME.colors,
    components: {
      TextInput: TextInput.extend({ defaultProps: INPUT_GUARD_PROPS }),
      NumberInput: NumberInput.extend({ defaultProps: INPUT_GUARD_PROPS }),
      Select: Select.extend({ defaultProps: INPUT_GUARD_PROPS }),
      Textarea: Textarea.extend({ defaultProps: INPUT_GUARD_PROPS }),
      FileInput: FileInput.extend({ defaultProps: INPUT_GUARD_PROPS }),
      TimePicker: TimePicker.extend({
        defaultProps: { ...INPUT_GUARD_PROPS, ...TIME_PICKER_DEFAULT_PROPS },
        styles: TIME_PICKER_STYLES,
      }),
      DatePickerInput: DatePickerInput.extend({
        defaultProps: { ...INPUT_GUARD_PROPS, ...DATE_PICKER_DEFAULT_PROPS },
      }),
      DateTimePicker: DateTimePicker.extend({
        defaultProps: {
          ...INPUT_GUARD_PROPS,
          ...DATE_PICKER_DEFAULT_PROPS,
          timePickerProps: { ...TIME_PICKER_DEFAULT_PROPS, styles: TIME_PICKER_STYLES },
          endTimePickerProps: { ...TIME_PICKER_DEFAULT_PROPS, styles: TIME_PICKER_STYLES },
        },
        styles: DATE_TIME_PICKER_STYLES,
      }),
    },
  });
}

/** Thème par défaut (avant chargement utilisateur). */
export const jlfcTheme = createJlfcTheme();
